import { fontWeights } from '@cash-me/web-tokens'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, borderWidths, fontSizes, lineHeights } = theme

export const Section = styled.section`
  width: 100%;

  @media (${media.desktop}) {
    padding-top: 7.5rem;
  }
`

export const Title = styled.h1`
  margin-bottom: ${space['spacing-md']};
  color: ${colors['neutral-text-default']};
  font-size: ${fontSizes['font-size-mobile-heading-3']};
  font-weight: ${fontWeights['font-weight-medium']};

  @media (${media.desktop}) {
    margin-bottom: ${space['spacing-xl']};
    font-size: ${fontSizes['font-size-heading-2']};
  }
`

export const AccordionWrapper = styled.div`
  margin-bottom: ${space['spacing-mega']};

  @media (${media.desktop}) {
    margin-bottom: 6rem;
  }

  .ds-accordion-item {
    margin-bottom: 0;
    border-bottom: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};

    summary {
      padding: ${space['spacing-sm']} 0;

      @media (${media.desktop}) {
        padding: ${space['spacing-md']} 0;
      }
    }

    a {
      font-size: ${fontSizes['font-size-body-2']};
    }

    > *:last-child {
      padding-bottom: ${space['spacing-md']};
    }

    table,
    td,
    th {
      border: 1px solid ${colors['neutral-text-weak']};
      color: ${colors['neutral-text-weak']};
    }

    td,
    th {
      padding: ${space['spacing-xs']};
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }
  }
`

export const List = styled.ul`
  margin-bottom: ${space['spacing-sm']};
`

export const ListItem = styled.li<{ clean?: boolean }>`
  margin-bottom: ${space['spacing-xxxs']};
  font-size: ${fontSizes['font-size-body-2']};
  color: ${colors['neutral-text-weak']};
  line-height: ${lineHeights['font-line-height-lg']};

  ${({ clean }) =>
    !clean &&
    `
    &:before {
      content: '●';
      display: inline-block;
      vertical-align: middle;
      padding-right: ${space['spacing-xxs']};
      font-size: ${fontSizes['font-size-caption']};
      color: ${colors['neutral-text-weak']};
    }
  `}
`
